import { createFileRoute, redirect } from "@tanstack/react-router";

// Bare /admin has nothing of its own to show, so it landed on an empty panel.
// Clients is the admin home, matching the sidebar's first item.
export const Route = createFileRoute("/_authed/$companySlug/admin/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$companySlug/admin/clients",
      params: { companySlug: params.companySlug },
    });
  },
});
